import { defineStore } from "pinia";

export const useBaseStore = defineStore({
  id: "base",
  state: () => ({
    name: "", // 站点标识
    gameId: "", //  游戏id
    moduleConfig: [], // 模块配置
    defaultLang: "", // 默认语言
    lang: "", // 当前语言
    preview: 0, // 是否预览
    sign: "", // 预览签名
    pageLoading: true, // 页面加载状态
    showPageBar: false, // 是否显示页面导航栏
    pageErrorTip: {
      visible: false,
      message: "",
    },
  }),
  getters: {
    navList: (state) => {
      return state.moduleConfig
        .filter((item) => item.IS_NAV == 1)
        .map((item) => {
          let text = "";
          try {
            const textObj = JSON.parse(item.MODULE_NAME_MULTILINGUAL || "{}");
            text = textObj[state.lang] || textObj[state.defaultLang];
          } catch (_err) {
            text = "";
          }
          return {
            ...item,
            MODULE_NAME_MULTILINGUAL: text,
          };
        });
    },
  },
  actions: {
    setName(name) {
      this.name = name;
    },
    setGameId(gameId) {
      this.gameId = gameId;
    },
    setModuleConfig(moduleConfig) {
      this.moduleConfig = moduleConfig;
    },
    setPageLoading(status) {
      this.pageLoading = status;
    },
    setLang(lang) {
      this.lang = lang;
    },
    setDefaultLang(lang) {
      this.defaultLang = lang;
    },
    setPreview(preview) {
      this.preview = preview;
    },
    setSign(sign) {
      this.sign = sign;
    },
    setShowPageBar(isShow) {
      this.showPageBar = isShow;
    },
    setPageErrorTipVisible(visible) {
      this.pageErrorTip.visible = visible;
    },
    setPageErrorTipMessage(mess) {
      this.pageErrorTip.message = mess;
    },
  },
});
